<h1 *ngIf="messageTranslatedTextKey" mat-dialog-title class="h-16 flex m-auto overflow-hidden">
  <span
    class="m-auto overflow-hidden flex static w-auto font-bold text-4xl colored-text"
  >
    {{messageTranslatedTextKey | translate}}
  </span>
</h1>

<mat-dialog-content
  class="tiwp-mat-dialog-content--flex-center overflow-hidden p-0 m-auto container"
>
  <button
    mat-button
    class="play-dialog__play"
    [mat-dialog-close]="true"
    cdkFocusInitial
    type="button"
  >
    <mat-icon>play_circle_outline</mat-icon>
  </button>
</mat-dialog-content>
